import react from "react";
import { Route, Routes, BrowserRouter, } from "react-router-dom";

import AdminRouter from "./AdminRouters";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<AdminRouter />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
